/**
 * @generated SignedSource<<8c6451baf5faa8f76af9494dd137413a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TaskTypeInput = {
  assignee_for_task?: string | null | undefined;
  color?: string | null | undefined;
  contract_invoice?: string | null | undefined;
  cost_code_id?: number | null | undefined;
  datetime?: string | null | undefined;
  description?: string | null | undefined;
  division_id?: number | null | undefined;
  end_datetime?: string | null | undefined;
  id?: string | null | undefined;
  name: string;
  number?: string | null | undefined;
  number_wbs?: string | null | undefined;
  owner_task_id?: string | null | undefined;
  phase_id?: number | null | undefined;
  priority?: number | null | undefined;
  project_id?: string | null | undefined;
  schedule_item_id?: string | null | undefined;
  start_datetime?: string | null | undefined;
  status?: number | null | undefined;
  sub_status?: number | null | undefined;
  subtask?: string | null | undefined;
  type?: number | null | undefined;
  value_equipment?: number | null | undefined;
  value_labour?: number | null | undefined;
  value_material?: number | null | undefined;
  value_other?: number | null | undefined;
  value_total?: number | null | undefined;
  wo_si?: string | null | undefined;
};
export type UpdateTaskMutation$variables = {
  input: TaskTypeInput;
};
export type UpdateTaskMutation$data = {
  readonly updateTask: {
    readonly assignee_for_task: string | null | undefined;
    readonly id: string | null | undefined;
    readonly scheduleItem: {
      readonly name: string;
    } | null | undefined;
    readonly schedule_item_id: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"TaskFragment">;
  } | null | undefined;
};
export type UpdateTaskMutation = {
  response: UpdateTaskMutation$data;
  variables: UpdateTaskMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "schedule_item_id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assignee_for_task",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateTaskMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Task",
        "kind": "LinkedField",
        "name": "updateTask",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ScheduleItem",
            "kind": "LinkedField",
            "name": "scheduleItem",
            "plural": false,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TaskFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateTaskMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Task",
        "kind": "LinkedField",
        "name": "updateTask",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ScheduleItem",
            "kind": "LinkedField",
            "name": "scheduleItem",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "color",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "datetime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "start_datetime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "start_format_datetime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "end_datetime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "project_id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "owner_task_id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Project",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sub_status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "end_format_datetime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "duration",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "priority",
            "storageKey": null
          },
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subtask",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "phase_id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "division_id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cost_code_id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contract_invoice",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "wo_si",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value_total",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value_equipment",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value_labour",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value_material",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value_other",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a0a79ab0d2b8eab09dca5769fe5f838b",
    "id": null,
    "metadata": {},
    "name": "UpdateTaskMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateTaskMutation(\n  $input: TaskTypeInput!\n) {\n  updateTask(input: $input) {\n    id\n    schedule_item_id\n    assignee_for_task\n    scheduleItem {\n      name\n      id\n    }\n    ...TaskFragment\n  }\n}\n\nfragment TaskFragment on Task {\n  id\n  name\n  color\n  datetime\n  start_datetime\n  start_format_datetime\n  end_datetime\n  schedule_item_id\n  assignee_for_task\n  project_id\n  owner_task_id\n  project {\n    id\n    name\n    number\n  }\n  type\n  status\n  sub_status\n  end_format_datetime\n  duration\n  description\n  priority\n  number\n  subtask\n  phase_id\n  division_id\n  cost_code_id\n  contract_invoice\n  wo_si\n  value_total\n  value_equipment\n  value_labour\n  value_material\n  value_other\n}\n"
  }
};
})();

(node as any).hash = "84d230f5bfe08644f78c5e81ffff61a0";

export default node;
